import { useEffect, useState } from "react";
import { AdminApi } from "api/admin.api";
import { TableList } from "./components/TableList";
import { DynamicTable } from "./components/DynamicTable";
import styles from "./AdminPanel.module.scss";

import ContactsMapSettings from "./components/ContactsMapSettings";
import VideosManager from "./components/VideosManager";
import TechnologiesSettings from "./components/TechnologiesSettings";
import PriceByDirectionsSettings from "./components/PriceByDirectionsSettings";
import EmployeeWorksManager from "./components/EmployeeWorksManager";
import PrivacyPolicySettings from "./components/PrivacyPolicySettings";
import LegalInfoSettings from "./components/LegalInfoSettings";
import { useFeedbackAlert } from "hooks/useFeedbackAlert";

export default function AdminPanelPage() {
  const [tables, setTables] = useState<string[]>([]);
  const [selectedTable, setSelectedTable] = useState<string | null>(null);

  useEffect(() => {
    AdminApi.getTables().then((res) => {
      const names = res.data.map((t: any) => t.table_name);

      const filtered = names.filter((name: string) => name !== "employee_work");

      setTables(filtered);
    });
  }, []);

  useFeedbackAlert()
  return (
    <div className={styles.admin_panel}>
      <div className={styles.sidebar}>
        <TableList
          tables={tables}
          selectedTable={selectedTable}
          onSelect={setSelectedTable}
        />
      </div>

      <div className={styles.content}>
        {selectedTable === "__contactsMap" ? (
          <ContactsMapSettings />
        ) : selectedTable === "__technologies" ? (
          <TechnologiesSettings />
        ) : selectedTable === "__priceByDirections" ? (
          <PriceByDirectionsSettings />
        ) : selectedTable === "__employeeWorks" ? (
          <EmployeeWorksManager />
        ) : selectedTable === "__privacyPolicy" ? (
          <PrivacyPolicySettings />
        ) : selectedTable === "__legalInfo" ? (
          <LegalInfoSettings />
        ) : selectedTable === "videos" ||
          selectedTable === "video" ||
          selectedTable === "__videos" ? (
          <VideosManager />
        ) : selectedTable ? (
          <DynamicTable table={selectedTable} />
        ) : (
          <div className={styles.form_block}>
            <h3>Выберите таблицу или раздел слева</h3>
          </div>
        )}
      </div>
    </div>
  );
}
